import { render, staticRenderFns } from "./FormSwitch.vue?vue&type=template&id=fda8c462&scoped=true"
import script from "./FormSwitch.vue?vue&type=script&lang=js"
export * from "./FormSwitch.vue?vue&type=script&lang=js"
import style0 from "./FormSwitch.vue?vue&type=style&index=0&id=fda8c462&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda8c462",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fda8c462')) {
      api.createRecord('fda8c462', component.options)
    } else {
      api.reload('fda8c462', component.options)
    }
    module.hot.accept("./FormSwitch.vue?vue&type=template&id=fda8c462&scoped=true", function () {
      api.rerender('fda8c462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form/FormSwitch.vue"
export default component.exports